module.exports = __webpack_public_path__ + "img/img21.8607b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img21.jpg
// module id = 318
// module chunks = 0